const propertyMixin = {
  data() {
    return {
      formColumn: [],
    };
  },
  methods: {
    resetCondition() {
      this.formColumn = [];
      const handleMap = {
        '02': this.resetCondition02,
        '03': this.resetCondition03,
        '04': this.resetCondition04,
        '05': this.resetCondition05,
      };
      handleMap[this.appendType]();
    },
    resetCondition02() {
      this.formColumn.push(
        {
          prop: 'name',
          name: '资产名称：',
          type: 'input',
          maxlength: 20,
          placeholder: '请输入资产名称',
          span: 8,
        },
        {
          prop: 'tempAssetType',
          name: '资产类型：',
          type: 'selectMultiple',
          placeholder: '请选择资产类型',
          relatedColumn: 'none',
          options: this.dictListMap['AssetType'],
          clearable: true,
          span: 8,
        },
        {
          prop: 'assetLocation',
          name: '资产位置：',
          type: 'input',
          maxlength: 50,
          placeholder: '请输入资产位置',
          span: 8,
        }
      );
      this.formColumn.push({
        prop: 'selfOwnedFlag',
        name: '是否自有：',
        type: 'select',
        placeholder: '请选择是否自有',
        options: this.dictListMap['yes-no'],
        changeMethod: 'changeCondition',
        span: 8,
      });
      this.formColumn.push({
        prop: 'leafFlag',
        name: '是否有子层级：',
        type: 'select',
        placeholder: '请选择有子层级',
        options: this.dictListMap['yes-no'],
        changeMethod: 'changeCondition',
        disabled: this.isChangeleafFlag || false,
        span: 8,
      });
      if (this.params.spaceDTO.selfOwnedFlag == '0') {
        this.formColumn.push({
          prop: 'rightParty',
          name: '权力方：',
          type: 'input',
          maxlength: 20,
          placeholder: '请输入权力方',
          span: 8,
        });
      }
      if (this.params.spaceDTO.leafFlag == '0') {
        this.formColumn.push({
          prop: 'area',
          name: '面积：',
          type: 'inputAmount',
          precision: 2,
          max: 9999999999999,
          placeholder: '请输入面积',
          span: 8,
        });
        this.formColumn.push({
          prop: 'selfUseFlag',
          name: '是否自用：',
          type: 'select',
          placeholder: '请选择是否自用',
          options: this.dictListMap['yes-no'],
          span: 8,
        });
      }
    },
    resetCondition03() {
      this.formColumn.push(
        {
          prop: 'name',
          name: '单元（楼栋）名称：',
          type: 'input',
          placeholder: '请输入单元（楼栋）名称',
          span: 12,
        },
        {
          prop: 'leafFlag',
          name: '是否有子层级：',
          type: 'select',
          placeholder: '请选择有子层级',
          options: this.dictListMap['yes-no'],
          changeMethod: 'changeCondition',
          disabled: this.isChangeleafFlag || false,
          span: 12,
        }
      );

      if (this.params.spaceDTO.leafFlag == '0') {
        this.formColumn.push(
          {
            prop: 'selfUseFlag',
            name: '是否自用：',
            type: 'select',
            placeholder: '请选择是否自用',
            options: this.dictListMap['yes-no'],
            changeMethod: 'changeCondition',
            span: 12,
          },
          {
            prop: 'area',
            name: '面积：',
            type: 'inputAmount',
            precision: 2,
            max: 9999999999999,
            placeholder: '请输入面积',
            span: 12,
          }
        );
      }
    },
    resetCondition04() {
      this.formColumn.push(
        {
          prop: 'name',
          name: '楼层名称：',
          type: 'input',
          placeholder: '请输入楼层名称',
          span: 12,
        },
        {
          prop: 'leafFlag',
          name: '是否有子层级：',
          type: 'select',
          placeholder: '请选择有子层级',
          options: this.dictListMap['yes-no'],
          changeMethod: 'changeCondition',
          disabled: this.isChangeleafFlag || false,
          span: 12,
        }
      );

      if (this.params.spaceDTO.leafFlag == '0') {
        this.formColumn.push(
          {
            prop: 'selfUseFlag',
            name: '是否自用：',
            type: 'select',
            placeholder: '请选择是否自用',
            options: this.dictListMap['yes-no'],
            changeMethod: 'changeCondition',
            span: 12,
          },
          {
            prop: 'area',
            name: '面积：',
            type: 'inputAmount',
            precision: 2,
            max: 9999999999999,
            placeholder: '请输入面积',
            span: 12,
          }
        );
      }
    },
    resetCondition05() {
      this.formColumn.push(
        {
          prop: 'name',
          name: '房间名称：',
          type: 'input',
          placeholder: '请输入房间名称',
          span: 8,
        },
        {
          prop: 'area',
          name: '面积：',
          type: 'inputAmount',
          precision: 2,
          max: 9999999999999,
          placeholder: '请输入面积',
          span: 8,
        },
        {
          prop: 'selfUseFlag',
          name: '是否自用：',
          type: 'select',
          placeholder: '请选择是否自用',
          options: this.dictListMap['yes-no'],
          changeMethod: 'changeCondition',
          span: 8,
        }
      );
    },
    changeCondition(val) {
      console.log('执行了', val);
      this.resetCondition();
    },
  },
};
export default propertyMixin;
